module.exports = __webpack_public_path__ + "static/media/community_1.ad2746ca.jpg";